export const PUBLISH_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  SCHEDULED: 'scheduled'
};
export const TARGETING_STATE = {
  AUDIENCE_FILTERS: 'audienceFilters' // audience targeting one-time filters
};